import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import { useEffect, useRef, useState } from "react"
import LoginAlert from "components/ModalLogin/LoginAlert"
import Link from "next/link"
import { Modal } from "components/ui"
import Image from "next/legacy/image"

export default function App(props) {
  const router = useRouter()
  const { toggleModalLogin, userInfo, signKey } = useStore()
  const { status, is_live, is_protected, id, thumbnail, thumbnail_banner, name } = props
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)
  const [srcImage, setSrcImage] = useState(thumbnail || thumbnail_banner)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // toggleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current && userInfo?.fullname) {
      router.push(`/league?id=${id}`)
    }
  }, [userInfo])

  useEffect(() => {
    if (isMonter.current && signKey) {
      router.push(`/league?id=${id}`)
    }
  }, [signKey])

  return (
    <>
      <Link href={`/league?id=${id}`}>
        <div
          onClick={onClick}
          className="flex flex-col bg-[#232323] px-3 pt-3 pb-4 gap-3 rounded-xl border border-transparent hover:border-white"
        >
          <Image
            width={760}
            height={428.1}
            src={srcImage}
            alt={name}
            className="rounded-xl object-cover"
            onError={() => setSrcImage("/placeholder_video.svg")}
          />
          <div className="text-sm md:text-base text-white font-medium line-clamp-1">{name}</div>
        </div>
      </Link>
      <Modal
        isOpen={isModal}
        onCancel={() => {
          setIsModal(false)
        }}
        showIcon={false}
      >
        <LoginAlert
          onCancel={() => {
            setIsModal(false)
          }}
          onNext={onNext}
        />
      </Modal>
    </>
  )
}
